var angular = require('angular')

require('./pages/appointment-error/appointment-error.component.js')
require('./pages/appointment-select/appointment-select.component.js')
require('./pages/appointment-create/appointment-create.component.js')
require('./pages/appointment-detail/appointment-detail.component.js')
require('./pages/appointment-cancel/appointment-cancel.component.js')

angular.module('AemBranchesAppointments')
  .controller('aemBranchesAppointmentsCtrl', ctrl)

ctrl.$inject = []

function ctrl () {
  var vm = this

  vm.$onInit = function () {
    vm.back = back
  }

  function back () {
    window.history.go(-1)
  }
}
